import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { NAV, POSITIONING } from "@/lib/site";

const MORE = [
  { to: "/for-organisations", label: "For Organisations" },
  { to: "/directory", label: "Support Directory" },
  { to: "/contact", label: "Contact" },
  { to: "/urgent-help", label: "Urgent Help" },
];
const LEGAL = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Use" },
  { to: "/safeguarding", label: "Safeguarding" },
  { to: "/accessibility", label: "Accessibility" },
  { to: "/brand", label: "Brand" },
];

const Col = ({ title, links }) => (
  <div>
    <h2 className="eyebrow !text-cream/70 mb-4 font-sans">{title}</h2>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l.to}><Link to={l.to} className="text-cream/90 hover:text-white underline-offset-4 hover:underline" data-testid={`footer-link-${l.to.replace(/\//g, "") || "home"}`}>{l.label}</Link></li>
      ))}
    </ul>
  </div>
);

export const SiteFooter = () => (
  <footer className="bg-[#1E2326] text-cream mt-24 no-print" data-testid="site-footer">
    <div className="container-site py-16 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
      <div className="max-w-sm">
        <Logo tone="light" />
        <p className="mt-5 text-cream/80 text-[0.95rem]">Because addiction affects more than one person.</p>
        <div className="mt-6 rounded-2xl border border-cream/15 p-5 text-[0.92rem] text-cream/85" data-testid="footer-scope-statement">
          <p><strong className="text-white">About our scope.</strong> {POSITIONING} We don't run a helpline and can't respond to personal situations.</p>
          <p className="mt-3">In immediate danger, call <a href="tel:999" className="underline font-semibold">999</a>. For urgent medical advice, call <a href="tel:111" className="underline font-semibold">NHS 111</a>. Samaritans: <a href="tel:116123" className="underline font-semibold">116 123</a>.</p>
        </div>
      </div>
      <Col title="Explore" links={NAV} />
      <Col title="Help & partners" links={MORE} />
      <Col title="Policies" links={LEGAL} />
    </div>
    <div className="border-t border-cream/10">
      <div className="container-site py-6 text-sm text-cream/70 flex flex-col sm:flex-row gap-2 justify-between">
        <p>© {new Date().getFullYear()} Addiction &amp; Us. General information only, not professional advice.</p>
        <p>Made in the UK, with care.</p>
      </div>
    </div>
  </footer>
);
